import { QueryHookOptions, useQuery } from '@apollo/react-hooks';
import { Query } from '../../../__generated__/pge-types';
import { getAllPlannedOutageEvents } from '../../../queries/outage.query';
import { useErrorNotification } from '../components/common/error-notification';
import { useEffect } from 'react';

export const useGetAllPlannedOutageEvents = () => {
  const { data, error, loading, refetch } = useQuery<Query>(
    getAllPlannedOutageEvents,
  );

  const { setErrorNotification } = useErrorNotification();

  useEffect(() => {
    error && setErrorNotification();
  }, [error]);

  return {
    plannedOutageData: data?.getAllPlannedOutageEvents,
    error,
    loading,
    refetch,
  };
};
